import { Box } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import * as React from "react";

// items: [{time: '10:32', text: 'Ticket #123 updated'}, ...]
export default function RecentActivityTimeline({
  title = "Recent Activity",
  items = [],
}) {
  return (
    <Box sx={{ height: "100%", border: "none" }}>
      <Typography component="h2" variant="subtitle2" gutterBottom>
        {title}
      </Typography>
      <List dense sx={{ maxHeight: 260, overflow: "auto" }}>
        {items.map((item, idx) => (
          <ListItem key={`${item.time}-${idx}`} sx={{ py: 0 }}>
            <ListItemText
              primary={item.text}
              secondary={item.time}
              primaryTypographyProps={{ variant: "body2" }}
              secondaryTypographyProps={{ variant: "caption" }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
